// Charts
import BubbleChart from "Components/chartsLibrary/BubbleChart"
import WidgetCompteur from "Components/chartsLibrary/Compteur"
import GaugeChart from "Components/chartsLibrary/GaugeChart"
import RadarChart from "Components/chartsLibrary/RadarChart"
import LineChart from "Components/chartsLibrary/LineChart"
import BarChart from "Components/chartsLibrary/BarChart"
import PieChart from "Components/chartsLibrary/PieChart"
import TreeMap from "Components/chartsLibrary/TreeMap"
import SolidGaugeChart from "Components/chartsLibrary/SolidGaugeChart"
import HeatMapRisk from "Components/chartsLibrary/HeatMapRisk"
import CloudWord from "Components/chartsLibrary/CloudWord"

// Widgets
import CalendarFilter from "Components/chartsLibrary/CalendarFilter"
import RedirectButton from "Components/chartsLibrary/RedirectButton"
import DropDownList from "Components/chartsLibrary/DropDownList"
import RangeFilter from "Components/chartsLibrary/RangeFilter"
import SearchBar from "Components/chartsLibrary/SearchBar"
import HierarchicalFilter from "Components/chartsLibrary/HierarchicalFilter"
import WidgetTable from "Components/chartsLibrary/WidgetTable"
import AgTable from "Components/chartsLibrary/AgTable"
import BasicTextV2 from "Components/chartsLibrary/BasicTextV2"
import MapSVG from "Components/chartsLibrary/Map"
import ProgressBar from "Components/chartsLibrary/ProgressBar"
import Image from "Components/chartsLibrary/Image"
import EvolutionWidget from "Components/chartsLibrary/EvolutionWidget"
import FillingGauge from "Components/chartsLibrary/FillingGauge/index.js"
import ActualityList from "Components/chartsLibrary/ActualityList"
import Pipeline from "Components/chartsLibrary/Pipeline/index.jsx"
import GanttChartV1 from "Components/chartsLibrary/GanttChartV1/index.jsx"
import GanttChartV2 from "Components/chartsLibrary/GanttChartV2"
import CaseCardMSF from "Components/chartsLibrary/CaseCardMSF/index.jsx"

import WidgetMultiTab from "Containers/WidgetMultiTab/index.js"
import GMap from "Components/chartsLibrary/GMap"

// Widgets V2
import ActualityRSS from "Shared/components/Widgets/ActualityRSS/ActualityRSS"
import LastSampleWidget from "Components/chartsLibrary/LastSampleWidget"

const widgetCategory = {
  CHART: "chart",
  TEXT: "text",
  FILTER: "filter",
}

//be cautious when changing type name.
//Created/Stored widget in DB has these type.
export const widgetsList = [
  {
    name: "Pipeline",
    type: "pipeline",
    category: "hidden",
    component: Pipeline,
  },
  {
    name: "Nuage de mot",
    type: "cloudWords",
    category: widgetCategory.CHART,
    component: CloudWord,
  },
  {
    name: "Pie",
    type: "pieChart",
    category: widgetCategory.CHART,
    component: PieChart,
  },
  {
    name: "Histogramme Cumulé 100",
    type: "stackedBar",
    category: widgetCategory.CHART,
    component: BarChart,
  },
  {
    name: "Line",
    type: "lineChart",
    category: widgetCategory.CHART,
    component: LineChart,
  },
  {
    name: "Cumulative Line",
    type: "cumulativeLineChart",
    category: widgetCategory.CHART,
    component: LineChart,
  },
  {
    name: "Stacked Area",
    type: "stackedArea",
    category: widgetCategory.CHART,
    component: LineChart,
  },
  {
    name: "Dropdown List",
    type: "dropdownList",
    category: widgetCategory.FILTER,
    component: DropDownList,
  },
  {
    name: "Compteur",
    type: "counter",
    category: widgetCategory.CHART,
    component: WidgetCompteur,
  },
  {
    name: "BarChart",
    type: "histogram",
    category: widgetCategory.CHART,
    component: BarChart,
  },
  {
    name: "Pyramide",
    type: "pyramide",
    category: widgetCategory.CHART,
    component: BarChart,
  },
  {
    name: "Tableau",
    type: "table",
    category: widgetCategory.CHART,
    component: WidgetTable,
  },
  {
    name: "Tableau 2.0 (bêta)",
    type: "ag_table",
    category: widgetCategory.CHART,
    component: AgTable,
  },
  {
    name: "Calendar",
    type: "calendar",
    category: widgetCategory.FILTER,
    component: CalendarFilter,
  },
  {
    name: "Radar",
    type: "radarChart",
    category: widgetCategory.CHART,
    component: RadarChart,
  },
  {
    name: "Map",
    type: "mapping",
    category: widgetCategory.CHART,
    component: MapSVG,
  },
  {
    name: "Map",
    type: "mappingFilter",
    category: widgetCategory.FILTER,
    component: MapSVG,
  },
  // {
  //   name: 'Basic text',
  //   type: 'basicText',
  //   category: widgetCategory.TEXT,
  //   component: BasicText
  // },
  {
    name: "Basic text",
    type: "basicText",
    category: widgetCategory.TEXT,
    component: BasicTextV2,
  },
  {
    name: "Redirect button",
    type: "redirectButton",
    category: widgetCategory.TEXT,
    component: RedirectButton,
  },
  {
    name: "Image",
    type: "image",
    category: widgetCategory.TEXT,
    component: Image,
  },
  {
    name: "Gauge",
    type: "gaugeChart",
    category: widgetCategory.CHART,
    component: GaugeChart,
  },

  {
    name: "Progress Bar",
    type: "progressBar",
    category: widgetCategory.CHART,
    component: ProgressBar,
  },
  {
    name: "TreeMap",
    type: "treeMap",
    category: widgetCategory.CHART,
    component: TreeMap,
  },
  {
    name: "Multi Gauge",
    type: "multiGauge",
    category: widgetCategory.CHART,
    component: SolidGaugeChart,
  },
  {
    name: "Multi Tab widget",
    type: "multiTabWidget",
    category: widgetCategory.CHART,
    component: WidgetMultiTab,
  },
  {
    name: "Evolution",
    type: "evolutionWidget",
    category: widgetCategory.CHART,
    component: EvolutionWidget,
  },
  {
    name: "Range Filter",
    type: "rangeFilter",
    category: widgetCategory.FILTER,
    component: RangeFilter,
  },
  {
    name: "Barre de recherche",
    type: "searchBar",
    category: widgetCategory.FILTER,
    component: SearchBar,
  },
  {
    name: "Filtre hiérarchique",
    type: "hierarchicalFilter",
    category: widgetCategory.FILTER,
    component: HierarchicalFilter,
  },
  {
    name: "BubbleChart",
    type: "bubbleChart",
    category: widgetCategory.CHART,
    component: BubbleChart,
  },
  // {
  //   name: "HeatMap",
  //   type: "heatMap",
  //   category: widgetCategory.CHART,
  //   component: HeatMap,
  // },
  {
    name: "HeatMap",
    type: "heatMapRisk",
    category: widgetCategory.CHART,
    component: HeatMapRisk,
  },
  {
    name: "FillingGauge",
    type: "fillingGauge",
    category: widgetCategory.CHART,
    component: FillingGauge,
  },
  {
    name: "ActualityList",
    type: "actualityList",
    category: widgetCategory.TEXT,
    component: ActualityList,
  },
  {
    name: "GoogleMap",
    type: "googleMap",
    category: widgetCategory.CHART,
    component: GMap,
  },
  {
    // Gantt specifique MSF : code en dur sur idCase / phase / step, reserve a useMSF.
    name: "GanttChart",
    type: "ganttChart",
    category: widgetCategory.CHART,
    component: GanttChartV1,
  },
  {
    name: "Gantt",
    type: "ganttChartV2",
    category: widgetCategory.CHART,
    component: GanttChartV2,
  },
  {
    name: "Liste affaires",
    type: "caseCardMSF",
    category: widgetCategory.CHART,
    component: CaseCardMSF,
  },
  {
    name: "Actualités",
    type: "actuality",
    category: widgetCategory.TEXT,
    component: ActualityRSS,
  },
  {
    name: "Last Sample",
    type: "lastSampleWidget",
    category: widgetCategory.TEXT,
    component: LastSampleWidget,
  },
]
